import api from "./api"; // your axios instance
const apmRoleNameGet = localStorage.getItem("role");
// ✅ Fetch submitted personal info applications
export const fetchSubmittedApplications = async (districtId ,zoneId) => {
  try {
    const url = "/api/personal-info/status";
    
    // Set the parameters for the request
    const params = {
      status: "SUBMITTED",
    };
    
    // Add districtId only if it's not null
    if (districtId != null&& (apmRoleNameGet === "PM" && apmRoleNameGet === 'APM OPERATIONS')) {
      params.districtId = districtId;
    }

    if(zoneId !==null&& apmRoleNameGet ==="APM Zone"){
      params.zoneId=zoneId;
    }

    // Make the request with the dynamic parameters
    const response = await api.get(url, { params });
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching submitted applications:", error);
    throw error;
  }
};



export const fetchSubmittedApplicationsHR = async () => {
  try {
    const response = await api.get("/api/personal-info/status", {
      params: { status: "VERIFIED" },
    });
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching submitted applications:", error);
    throw error;
  }
};

export const fetchSubmittedApplicationsRejected = async () => {
  try {
    const response = await api.get(`api/personal-info/rejected`);
    return response.data ?? [];
  } catch (error) {
    console.error("Error fetching submitted applications:", error);
    throw error;
  }
};


export const resubmitMails=async(districtId,zoneId)=>{
  let url = `/api/personal-info/resubmit`
   if (districtId != null &&( apmRoleNameGet === "PM" && apmRoleNameGet === 'APM OPERATIONS')) {
    url += `?districtId=${districtId}`;
  }
  if (zoneId != null && apmRoleNameGet === "APM Zone") {
    url += `?zoneId=${zoneId}`
  }
  const response = await api.get(url)
  return response;



}